import axios from "../../apiFc24";
import { MetaRating } from "../../privateRequests/squad-builder/get-meta-ratings";

interface GetEvoTreeNodeProps {
  resourceId: number;
  nodeId: string;
  playerRoleId: number;
  evoPathId?: number;
}

export type EvoPlayer = {
  attributes: number[];
  playStyles: number[];
  possiblePositions: string[];
  preferredPosition: string;
  rating: number;
  skillMoves: 1 | 2 | 3 | 4 | 5;
  versionId: number;
  weakFoot: 1 | 2 | 3 | 4 | 5;
  inGamePlayer: {
    [label: string]: number;
  };
  metaRatings: MetaRating[];
  playStylesPlus?: number[];
};

export const getEvoTreeNode = async ({
  resourceId,
  nodeId,
  playerRoleId,
  evoPathId,
}: GetEvoTreeNodeProps) => {
  const res = await axios.get<EvoPlayer>(
    `/players/${resourceId}/evolution-tree/${nodeId}?player-role-id=${playerRoleId}${
      evoPathId ? `&evoPathId=${evoPathId}` : ""
    }`,
  );
  return res.data;
};
